import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d535538"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "加载中...", -1))

import { onMounted, onUnmounted, ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const container = ref()
let loadingAnimation
onMounted(() => {
  loadingAnimation = window.bodymovin.loadAnimation({
    container: container.value,
    path: 'https://oss.shumeipan.cn/hezi/images/static/web/loading2_golden.json',
    loop: true,
    autoplay: true,
    name: 'loading',
  })
})

onUnmounted(() => {
  if (loadingAnimation?.destroy) loadingAnimation?.destroy()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "load-animation",
      ref_key: "container",
      ref: container
    }, null, 512),
    _hoisted_2
  ]))
}
}

})